import { FormattedMessage } from 'react-intl';
import { Card, Stack, Typography } from '@mui/material';

export type StepProps = {
  children: React.ReactNode;
};

export const Step = ({ children }: StepProps): React.JSX.Element => (
  <Stack alignItems="center" display="flex" justifyContent="center" spacing={2}>
    <Typography variant="h2">
      <FormattedMessage defaultMessage="Let’s secure your account" />
    </Typography>
    <Typography variant="body1">
      <FormattedMessage defaultMessage="To help protect your account, we will need to verify your phone number" />
    </Typography>
    <Card sx={{ maxWidth: 377, p: [6, 5] }}>
      <Stack alignItems="center" spacing={3}>
        <Typography variant="h3">
          <FormattedMessage defaultMessage="Phone Verification" />
        </Typography>
        {children}
      </Stack>
    </Card>
  </Stack>
);
